import ModalComponent from "../../../components/modals";
import LoadingFeedback, { useLoadingState } from "../../../components/loadingFeedback";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useForm } from "react-hook-form";
import { Grid } from "@mui/material";
import SimpleTable from "../../../components/tables/simpleTable";
import { useState } from "react";
import { icons } from "../../../constants";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { months, monthsWithAll } from "../../../constants/selectData";
import { useEffect } from "react";
import FormTextField from "../../../components/textField/formTextField";
import { hasAnyRoleUtil } from "../../../services/roleService";
import { useSelector } from "react-redux";
import {
  callApiAsync,
  getAnalisisIndicatorAnalysisByGoal,
  getAnalisisIndicatorTecnology,
  getServiceOrderAnalysisbyTableId,
  getServiceOrderAnalysisYearsByTableId,
  getServiceOrderAnalysisData,
  saveRegisterIndicatorAnalysisByTime
} from "../../../services/apiService";
import { analisisTableType } from "../../../constants/enums";
import ToastNotification from "../../../components/toastNotification";
import {
  getCurrentYear,
  getMonthName,
  getCurrentMonth
} from "../../../utils/dateUtils";
import { BIOMEDICAL_DASHBOARD_ANALYSIS_EDIT_ROLES } from "../../../constants/biomedicalRoles";

const BiomedicalTecnologyAnalisisModal = ({
  open,
  handleClose,
  data,
  tableType
}) => {
  const [dataTable, setDataTable] = useState([]);
  const [dataFilteredTable, setFilteredDataTable] = useState([]);
  const [addModal, setAddModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showToast, setShowToast] = useState(false);
  const [yearFilter, setYearFilter] = useState([]);
  const [monthFilter, setMonthFilter] = useState([]);

  const [toastConfig, setToastConfig] = useState({
    severity: "",
    summary: "",
    detail: ""
  });
  const [saving, setSaving] = useState(false);

  const userData = useSelector((state) => state.userData.userData);

  const isEditIndicator = hasAnyRoleUtil(
    BIOMEDICAL_DASHBOARD_ANALYSIS_EDIT_ROLES,
    userData.roleList
  );

  const analisisColumns = [
    {
      field: "month_year",
      header: "Mes/Año",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {getMonthName(rowData.month) + " - " + rowData.year}
        </p>
      ),
      columnWidth: "115px"
    },
    { field: "real_value", header: "Real", columnWidth: "180px" },
    { field: "goal_value", header: "Meta", columnWidth: "180px" },
    { field: "comment", columnType: "tooltip",  columnWidth: "450px",header: "Analisis Indicador" },
    ...(isEditIndicator
      ? [
          {
            field: "actions",
            header: "",
            columnType: "actionButtons"
          }
        ]
      : [])
  ];

    const ToolTipDescription = (text) => {
    return (
      <div>
        <p className="tooltip-title">Descripción:</p>
        <div>
          <p className="tooltip-text">{text}</p>
        </div>
      </div>
    );
  };

  const [loadingTable, setLoadingTable] = useLoadingState();
  const [loadingValues, setLoadingValues] = useLoadingState();
  const getSelectData = async (monthData, activityId) => {
    if (tableType === analisisTableType.engineeringAct) {
      await callApiAsync(
        () => getAnalisisIndicatorTecnology(monthData, tableType),
        (data) => {
          setValue("real_value", data?.value);
          setValue("goal_value", data?.meta);
        },
        setLoadingValues
      );
    } else {
      await callApiAsync(
        () => getAnalisisIndicatorAnalysisByGoal(monthData, activityId),
        (data) => {
          setValue("goal_value", data?.goal);
          setValue("real_value", data?.completionPercentage);
        },
        setLoadingValues
      );
    }
  };

  const buildYearOptions = (yearsFromApi) => {
    const currentYear = getCurrentYear();
    const minYear = Math.min(2025, currentYear - 1);
    const yearSet = new Set([
      currentYear,
      currentYear - 1,
      minYear,
      ...(yearsFromApi || [])
    ]);
    const sorted = Array.from(yearSet).sort((a, b) => a - b);
    return sorted.map((y) => ({ name: String(y), value: y }));
  };

  const getTableData = async (year, month) => {
    if (tableType === analisisTableType.engineeringAct) {
      const effectiveYear = year != null ? year : getCurrentYear();
      const effectiveMonth =
        month != null && month !== "" && month !== "all" ? month : undefined;

      await callApiAsync(
        () =>
          getServiceOrderAnalysisbyTableId(tableType, {
            year: effectiveYear,
            ...(effectiveMonth != null ? { month: effectiveMonth } : {})
          }),
        (responseData) => {
          const list = Array.isArray(responseData) ? responseData : [];
          setValue("goal_value", "80%");
          setDataTable(list);
          setFilteredDataTable(list);
        },
        setLoadingTable
      );
    } else {
      if (!data) {
        setDataTable([]);
        setFilteredDataTable([]);
        return;
      }
      await callApiAsync(
        () => getServiceOrderAnalysisData(data),
        (responseData) => {
          const list = Array.isArray(responseData) ? responseData : [];
          setDataTable(list);
          setFilteredDataTable(list);
          getAvailablePastMonths();
          setYearFilter(
            buildYearOptions(list.map((item) => item.year))
          );
        },
        setLoadingTable
      );
    }
  };

  const getAvailablePastMonths = () => {
    const currentYear = getCurrentYear();
    const currentMonth = getCurrentMonth();

    const registeredMonths = new Set(
      dataTable
        .filter((item) => item.year === currentYear)
        .map((item) => item.month)
    );

    setMonthFilter(
      months.filter(
        (m) => m.value < currentMonth && !registeredMonths.has(m.value)
      )
    );
  };

  const handleChangeMonth = () => {
    const monthData = getValues().month;
    const activityId = data;
    getSelectData(monthData, activityId);
  };

  const {
    control,
    getValues,
    setValue,
    reset,
    watch,
    formState: { errors, isValid }
  } = useForm({
    defaultValues: {
      year: getCurrentYear(),
      monthFilter: getCurrentMonth()
    }
  });

  const watchYear = watch("year");
  const watchMonth = watch("monthFilter");

  const handleClearFilters = () => {
    const defaultYear = getCurrentYear();
    reset({ year: defaultYear, monthFilter: "all" });

    if (tableType === analisisTableType.engineeringAct) {
      getTableData(defaultYear, undefined);
    } else {
      setFilteredDataTable(dataTable);
    }
  };

  const handleOpenAddModal = (row) => {
    setSelectedRow(row);
    setAddModal(true);

    setValue("id", row.id);
    setValue("month", row.month);
    setValue("real_value", row.real_value);
    setValue("goal_value", row.goal_value);
    setValue("comment", row.comment);
  };

  const handleCloseAdd = () => {
    setValue("id", null);
    setValue("month", null);
    setValue("real_value", "");
    setValue("goal_value", "");
    setValue("comment", "");
    setAddModal(false);
  };

  const buttonTable = () => {
    return [
      {
        type: "icon",
        icon: icons.editBlue,
        onClick: (data) => handleOpenAddModal(data)
      }
    ];
  };

  const handleSave = async () => {
    if (saving) return;
    const filters = getValues();
    const currentYear = getCurrentYear();

    const selectedMonth = filters.month;
    const isDuplicate = dataTable.some((item) => {
      const isSameMonth = item.month === selectedMonth;
      const isSameYear = item.year === currentYear;
      const isDifferentRow = !selectedRow || item.id !== selectedRow.id;
      return isSameMonth && isSameYear && isDifferentRow;
    });

    if (isDuplicate) {
      setToastConfig({
        severity: "warn",
        summary: "Error al validar.",
        detail: "Ya existe un análisis registrado para este mes y año."
      });
      setShowToast(true);
      return;
    }

    const dataToSend = {
      id: selectedRow ? selectedRow.id : 0,
      tableType: tableType ? tableType : analisisTableType.indicatorAnalisis,
      activityId: data,
      ...filters
    };

    setSaving(true);
    try {
      await callApiAsync(
        () => saveRegisterIndicatorAnalysisByTime(dataToSend),
        () => {
          handleCloseAdd();
          if (tableType === analisisTableType.engineeringAct) {
            const { year, monthFilter } = getValues();
            getTableData(year, monthFilter);
          } else {
            getTableData();
          }
          setValue("id", null);
          setValue("month", null);
          setValue("real_value", "");
          setValue("goal_value", "");
          setValue("comment", "");
        }
      );
    } finally {
      setSaving(false);
    }
  };

  /** Meses pasados que aún no tienen análisis (para no mostrar duplicados al agregar) */
  const getMonthsAvailableForAdd = () => {
    const currentYear = getCurrentYear();
    const currentMonth = getCurrentMonth();
    const registeredMonths = new Set(
      (dataTable || [])
        .filter((item) => item.year === currentYear)
        .map((item) => item.month)
    );
    return months.filter(
      (m) => m.value < currentMonth && !registeredMonths.has(m.value)
    );
  };

  useEffect(() => {
    if (!open) return;

    if (tableType === analisisTableType.engineeringAct) {
      const defaultYear = getCurrentYear();
      const defaultMonth = getCurrentMonth();
      setYearFilter(buildYearOptions([defaultYear]));

      callApiAsync(
        () => getServiceOrderAnalysisYearsByTableId(tableType),
        (response) => {
          const years = response?.years || [];
          setYearFilter(buildYearOptions(years));
          reset({ year: defaultYear, monthFilter: defaultMonth });
        },
        setLoadingTable
      );
    } else {
      getTableData();
    }
  }, [open]);

  useEffect(() => {
    if (!open || tableType !== analisisTableType.engineeringAct) return;
    const y = watchYear != null ? Number(watchYear) : getCurrentYear();
    if (!Number.isInteger(y)) return;
    const isEmptyMonth =
      watchMonth === "" || watchMonth === "all" || watchMonth == null;
    const m = isEmptyMonth ? undefined : Number(watchMonth);
    if (m !== undefined && !Number.isInteger(m)) return;
    getTableData(y, m);
  }, [open, watchYear, watchMonth]);

  return (
    <div>
      <ModalComponent
        open={open}
        width="1100px"
        maxWidth="calc(100vw - 32px)"
        handleClose={handleClose}
        title={""}
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <div className="IHContainer j-space-between">
          <h1 className="title-bio-details-chard">Análisis de Indicador</h1>
          {isEditIndicator && (
            <LaddaButton
              height={"35px"}
              variant="contained"
              type="submit"
              onClick={() => handleOpenAddModal(null)}
            >
              <img className="btn-icon mr-10" src={icons.plusIcon} alt="icon" />{" "}
              Agregar
            </LaddaButton>
          )}
        </div>
        <div className="filter-container">
          <form>
            <Grid container spacing={1} alignItems="center">
              <Grid item xs={12} md={2}>
                <div className="mid-filter-margin">
                  <SimpleSelect
                    name="monthFilter"
                    control={control}
                    label="Mes"
                    options={monthsWithAll}
                    margin={"0"}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={2}>
                <SimpleSelect
                  name="year"
                  control={control}
                  label="Año"
                  options={yearFilter}
                  // onChange={handleChange}
                  margin={"0"}
                />
              </Grid>
              <Grid item xs />
              <Grid item xs={12} md={1.5}>
                <div className="IHContainer j-end">
                  <LaddaButton
                    variant="contained"
                    onClick={handleClearFilters}
                    margin={"0"}
                    width={"52px"}
                  >
                    <img
                      className="btn-icon"
                      src={icons.clearFilterWhite}
                      alt="icon"
                    />
                  </LaddaButton>
                </div>
              </Grid>
            </Grid>
          </form>
        </div>

        <SimpleTable
          loading={loadingTable}
          data={dataFilteredTable}
          tableStyle={{ minWidth: "870px" }}
          columns={analisisColumns}
          buttons={buttonTable()}
          tooltipFragment={ToolTipDescription}
          isPaginated
          rows={10}
        />

        {!dataFilteredTable?.length && (
          <p style={{ textAlign: "center", marginTop: "10px", color: "#999" }}>
            No hay datos disponibles
          </p>
        )}
      </ModalComponent>

      <ModalComponent
        open={addModal}
        handleClose={handleCloseAdd}
        title={""}
        actions={<div className="HContainer j-center w-complete"></div>}
      >
        <br />
        <LoadingFeedback loading={loadingValues} variant="spinner" />
        <form>
          <Grid justifyContent="flex-end" container spacing={1}>
            <Grid item xs={12} md={4}>
              <p className="info-label">Fecha:</p>

              <SimpleSelect
                name="month"
                control={control}
                label=""
                options={selectedRow ? months : getMonthsAvailableForAdd()}
                margin={"0"}
                onChange={() => handleChangeMonth()}
                disabled={selectedRow ? true : false}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <p className="info-label">Real (%):</p>

              <FormTextField
                name={"real_value"}
                control={control}
                error={errors.engineeringReport}
                margin={"0"}
                disabled={true}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <p className="info-label">Meta (%):</p>
              <FormTextField
                name={"goal_value"}
                control={control}
                error={errors.engineeringReport}
                margin={"0"}
                disabled={true}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <p className="info-label">Analisis Indicador:</p>
              <FormTextField
                name={"comment"}
                control={control}
                isTextArea={true}
                error={errors.engineeringReport}
                maxLength={1000}
                rows={3}
                margin={"0"}
              />
            </Grid>
          </Grid>

          <div
            className="j-center mt-20"
            style={{ display: "flex", gap: "10px" }}
          >
            <LaddaButton
              variant="contained"
              onClick={() => handleSave()}
              disabled={saving}
            >
              Guardar
            </LaddaButton>
          </div>
        </form>
      </ModalComponent>

      <ToastNotification
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
        showToast={showToast}
        setShowToast={setShowToast}
      />
    </div>
  );
};

export default BiomedicalTecnologyAnalisisModal;
